import './payment.scss';

import { Outlet } from "react-router-dom";

import { FilterPaymentProvider } from "./filter-payment/filter-payment.context";

export function Payment() {
  return (
    <div id="ShellPayment" className="payment">
       <FilterPaymentProvider>
        <Outlet />
      </FilterPaymentProvider>
    </div>
  );
}

export default Payment;
